// extracted by mini-css-extract-plugin
export default {"avatar":"AvatarIcon_avatar__rykGP"};